export default __webpack_public_path__ + "static/media/figo-card-logo.1a0578df.svg";